import "./style.css";

// Fallback enquanto o backend nao retorna nada (mesmo padrao do Indicadores).
export default function Historia({ history, editMode, onError, onChange }) {
  const titulo = history?.title ?? "Nossa história";
  const textoCadastrado = typeof history?.text === "string" ? history.text.trim() : "";
  const paragrafos = textoCadastrado
    ? textoCadastrado.split(/\n{2,}/).filter(Boolean)
    : [];
  const paragrafo = textoCadastrado;

  const handleLimpar = () => {
    onChange("title", "");
    onChange("text", "");
  };

  if (editMode) {
    return (
      <section className="historia">
        <input
          className="quem-somos-page-h2__input"
          value={titulo || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />

        <textarea
          className="quem-somos-page-p__textarea"
          value={paragrafo || ""}
          onChange={(e) => onChange("text", e.target.value)}
        />

        <button
          type="button"
          className="historia__limpar-btn"
          onClick={handleLimpar}
        >
          Limpar
        </button>

      </section>
    );
  }


  return (
    <section className="historia">
      <h2 className="historia__titulo">{titulo}</h2>
      {paragrafos.map((texto, index) => (
        <p className="historia__paragrafo" key={index}>
          {texto}
        </p>
      ))}
    </section>
  );
}
